// eslint-disable-next-line import/prefer-default-export
export const AD_TYPES = ["sales", "rental", "booking", "wanted"];
